<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.name" placeholder="输入课程名称" @on-search="handleSearch" style="width:100%;" />
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row style='margin-bottom: 20px;'>
                <Col span="10">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span="6">
                    <Select v-model="formItem.type_id" placeholder="课程类型" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in typeList" :value="item.type_id" :key="item.type_id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right' size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
        <Modal v-model='editClassModal' width='900' title='编辑课次'>
            <Tree :data="treeData" :render="renderContent"></Tree>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancel'>关闭</Button>
            </div>
        </Modal>
        <Modal v-model="classModel" width="480" title='章节' @on-cancel='cancelChapter'>
            <Form ref="chapterFrom" :model="chapterFrom" label-position="top">
                <FormItem label="章节名称" prop='name' v-if='!chapterLevel'>
                    <Input v-model="chapterFrom.name" type="text" placeholder="请输入..." style="width:260px;"></Input>
                </FormItem>
                <FormItem label="章节类型" prop='type' v-if='chapterLevel'>
                    <Radio-group v-model="chapterFrom.type">
                        <Radio label="1">组图</Radio>
                        <Radio label="2">视频</Radio>
                        <Radio label="3">组图+音频</Radio>
                    </Radio-group>
                </FormItem>
                <FormItem label="图片" prop='images' v-if='chapterFrom.type==1||chapterFrom.type==3&&chapterLevel'>
                    <UploadImg v-if='classModel' @getPicList="getChapterImgList" :getList='chapterFrom.images' message='100' id='images'></UploadImg>
                </FormItem>
                <FormItem label="视频" prop='source_url' v-if='chapterFrom.type==2&&chapterLevel'>
                    <UploadVideo @getVideos="getVideos" :getVideourl='chapterFrom.source_url' message='1'></UploadVideo>
                </FormItem>
                <FormItem label="音频" prop='source_url' v-if='chapterFrom.type==3&&chapterLevel'>
                    <Audio @getAudioList="getAudioList" :getList='chapterFrom.source_url' message='1'></Audio>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelChapter'>取消</Button>
                <Button type="primary" shape="circle"  @click="okChapter">保存</Button>
            </div>
        </Modal>
        <Modal v-model="lessonContentModel" width="400" title='查看' @on-cancel='cancelLessonContent'>
            <Carousel v-model="carouselVal" loop v-if='lessonContentType==1||lessonContentType==3&&lessonContentModel'>
                <CarouselItem v-for='item in imgContent' style='text-align:center' :key='item'>
                    <img :src='item' width="100%"></img>
                </CarouselItem>
            </Carousel>
            <video v-else-if="lessonContentType==2&&lessonContentModel" :src='lessonContentVideo' controls="controls" autoplay="autoplay" style='margin:0 auto;width:60%;display:block'>
                    <source :src='lessonContentVideo' type="video/mp4">
                    <source :src='lessonContentVideo' type="video/mov">
                </video>
            <audio v-if="lessonContentType==3&&lessonContentModel" :src="audioUrl" autoplay controls="controls"></audio>
        </Modal>
        <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
    
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>

<script>
    import {
        fetchTableList,
        fetchChapterInfo,
        setDel,
        modifySave
    } from '@/api/studentCourseCatalogue'
    import {
        fetchLessonTypeList,

    } from '@/api/common'
    
    import UploadImg from '../common/picture.vue'
    import UploadVideo from '../common/videos.vue'
    import Audio from '../common/audio.vue'

    
    
    export default {
        name: 'user-components',
        components: {
            UploadImg,
            UploadVideo,
            Audio
        },
        data() {
            return {
                total_count: 0, //列表总条数
                carouselVal: 0, //跑马灯索引
                imgContent: [], //跑马灯图片
                formItem: {
                    page: 1, //列表当前页数
                    page_size: 10,
                    name: '',
                    start_time: '',
                    end_time: '',
                    type_id:'',
                },
                start_time: '',
                end_time: '',
                typeList: [],
                defaultMsg: '',
                config: {
                    initialFrameWidth: null,
                    initialFrameHeight: 350
                },
                chapter_id:'',
                chapterLevel: false,
                lessonContentModel:false,
                lessonContentType: '', //课程内容类型

                editClassModal: false, //树状图弹出层状态
                classModel: false, //添加课次弹出层状态
                lessonId: '', //课程id

                chapterFrom: {
                    lesson_id:'',
                    parent_id:'',
                    name:'',
                    type:'',
                    images:'',
                    source_url:'',
                },
                chapterLevel: false, //是否添加第三层章节
                remindContent: '', //提醒内容
                remindModal: false, //提醒弹层状态
                treeData: [{
                    title: '课次',
                    level: '0',
                    id: 0,
                    parent_id: 0,
                    chapter_id: 0,
                    expand: true,
                    children: [],
                    render: (h, {
                        root,
                        node,
                        data
                    }) => {
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('span', [
                                h('Icon', {
                                    props: {
                                        type: 'ios-folder-outline'
                                    },
                                    style: {
                                        marginRight: '8px'
                                    }
                                }),
                                h('span', data.title)
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
                               
                            ])
                        ]);
                    }
                }],
                upProps: {
                    type: 'info',
                    size: 'small',
                    ghost: true

                },
                downProps: {
                    type: 'info',
                    size: 'small',
                    ghost: true

                },
                appendProps: {
                    type: 'primary',
                    size: 'small',
                    ghost: true
                },
                removeProps: {
                    type: 'error',
                    size: 'small',
                    ghost: true
                },
                editIncellColumns: [{
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
    
                    {
                        title: '课程名称',
                        align: 'center',
                        key: 'name',
    
                    },
                    {
                        title: '课程类型',
                        align: 'center',
                        key: 'type_name',
                    },
    
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div', '上架')

                            }else{
                                return h('div', '下架')

                            }
                        }

                    },
    
                    {
                        title: '上架时间',
                        align: 'center',
                        key: 'publish_at',
                        width: 150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 160,
                        render: (h, params) => {
    
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        ghost: true
    
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editChapter(params.row.lesson_id)
                                        }
                                    }
                                }, '编辑课次'),
    
                            ])
                        }
                    }
    
                ], //列表
                editIncellData: [], //列表数据
            };
        },
        methods: {
            //获取列表数据
            getData() {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res = res.data;
                    this.$Loading.finish();
                    if (res.code == 200) {
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getLessonTypeList(){
                fetchLessonTypeList().then(res => {
                    res = res.data;
                    this.$Loading.finish();
                    if (res.code == 200) {
                        this.typeList = res.data;
                    
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 添加章节
            append(data) {
                this.modelLabel='添加';

                if (data.level == 3) {
                    this.chapterLevel = true;
                } else {
                    this.chapterLevel = false;
                }
    
                this.appendData = data;
                this.chapterFrom.chapter_id = '';
                this.chapterFrom.parent_id = data.parent_id;
                this.chapterFrom.lesson_id = data.lesson_id;
                this.chapterFrom.name = '';
                this.chapterFrom.type = '';
                this.chapterFrom.images = [];
                this.chapterFrom.source_url = '';
    
                this.classModel = true;
            },
            // 编辑课次
            editChapter(id) {
                this.lessonId = id;
                this.chapterFrom.lesson_id = id;
                fetchChapterInfo({
                    lesson_id: id,
                    member_type:1
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        var resData = res.data;
                       
                        var arr = [];
                        if (!resData.length) {
                            var arr = [];
                        } else {
                           resData.forEach(function(lesson) {
                                    var obj = {};
                                    obj.title = lesson.name;
                                    obj.chapter_id = lesson.chapter_id;
                                    obj.lesson_id = lesson.lesson_id;
                                    obj.parent_id = lesson.parent_id;
                                    obj.level = lesson.level;
                                    
                                    // obj.expand = true;
                                    obj.children = [];
                                  
                                    lesson.children.forEach(function(block) {
                                        var moduleObj = {};
                                        moduleObj.title = block.name;
                                        moduleObj.lesson_id = block.lesson_id;
                                        moduleObj.parent_id = block.parent_id;
                                        moduleObj.chapter_id = block.chapter_id;
                                        moduleObj.level = block.level;
                                        moduleObj.expand = true;
                                        moduleObj.children = [];
                                        obj.children.push(moduleObj)
                                     
                                        block.children.forEach(function(link) {
                                            var linkObj = {};
                                            linkObj.title = link.name;
                                            linkObj.lesson_id = link.lesson_id;
                                            linkObj.chapter_id = link.chapter_id;
                                            linkObj.parent_id = link.parent_id;
                                            linkObj.level = link.level;
                                            linkObj.expand = true;
                                            linkObj.children = [];
                                            moduleObj.children.push(linkObj)
                                            link.children.forEach(function(item) {
                                                var itemObj = {};
                                                if (item.type == 1) {
                                                    itemObj.title = '图片类：';
                                                } else if (item.type == 2) {
                                                    itemObj.title = '视频类：';
    
                                                } else if (item.type == 3) {
                                                    itemObj.title = '组图+音频类：';
                                                } 
                                                itemObj.lesson_id = item.lesson_id;
                                                itemObj.chapter_id = item.chapter_id;
                                                itemObj.parent_id = item.parent_id;
                                                itemObj.type = item.type;
                                                itemObj.level = item.level;
                                                itemObj.images = item.images;
                                                itemObj.source_url = item.source_url;
                                                itemObj.drawing_note = item.drawing_note;
                                                itemObj.question = item.question;
                                                itemObj.note_key = item.note_key;
                                                linkObj.children.push(itemObj);
                                            })
                                        })
                                   
    
                                    })
                                  
    
                                    arr.push(obj)
                                })
                        }
                        this.treeData[0].children = arr;
    
                        this.editClassModal = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
           renderContent(h, {
                root,
                node,
                data
            }) {
                if (data.level == 1) {
                    return h('span', {
                        style: {
                            display: 'inline-block',
                            width: '100%'
                        }
                    }, [
                        h('span', [
                            h('Icon', {
                                props: {
                                    type: 'ios-paper-outline'
                                },
                                style: {
                                    marginRight: '8px'
                                }
                            }),
                            h('span', data.title)
                        ]),
                        h('span', {
                            style: {
                                display: 'inline-block',
                                float: 'right',
                                marginRight: '32px'
                            }
                        }, [
                          
                          
                           
                            
                        ])
                    ]);
                } else if( data.level == 2 ||data.level == 3){
                    return h('span', {
                        style: {
                            display: 'inline-block',
                            width: '100%'
                        }
                    }, [
                        h('span', [
                            h('Icon', {
                                props: {
                                    type: 'ios-paper-outline'
                                },
                                style: {
                                    marginRight: '8px'
                                }
                            }),
                            h('span', data.title)
                        ]),
                        h('span', {
                            style: {
                                display: 'inline-block',
                                float: 'right',
                                marginRight: '32px'
                            }
                        }, [
                          
                          
                            h('Button', {
                                props: Object.assign({}, this.removeProps, {
                                    icon: 'minus-round'
                                }),
                                style: {
                                    marginRight: '8px'
                                },
                                on: {
                                    click: () => {
                                        this.remove(data)
                                    }
                                }
                            }, '删除'),
                            
                        ])
                    ]);
                }else {
                    if (data.type == 1) {
                        var content = [];
                        data.images.forEach((item, index) => {
                            content.push(h('img', {
                                attrs: {
                                    src: 'https://storage.art-kangaroo.com' + item
                                },
                                style: {
                                    width: '100px',
                                    marginRight: '10px'
                                },
                                on: {
                                    click: () => {
                                        this.lookContent(data, index)
                                    }
                                }
                            }, ))
                        })
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('div', data.title),
                            h('span', content),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
    
                                h('Button', {
                                    props: Object.assign({}, this.removeProps, {
                                        icon: 'minus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(data)
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'plus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editorContent(data)
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'plus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.lookContent(data)
                                        }
                                    }
                                }, '查看'),
    
                            ])
                        ]);
                    } else if (data.type == 2) {
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('div', data.title),
                            h('span', [
                                h('video', {
                                    attrs: {
                                        src: 'https://storage.art-kangaroo.com' + data.source_url
                                    },
                                    style: {
                                        width: '100px',
                                        marginRight: '10px'
                                    },
                                    on: {
                                        click: () => {
                                            this.lookContent(data)
                                        }
                                    }
                                }, data.title)
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
    
                                h('Button', {
                                    props: Object.assign({}, this.removeProps, {
                                        icon: 'minus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(data)
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'plus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editorContent(data)
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'plus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.lookContent(data)
                                        }
                                    }
                                }, '查看'),
    
                            ])
                        ]);
                    } else if (data.type == 3) {
                        var content = [];
                        data.images.forEach((item, index) => {
                            content.push(h('img', {
                                attrs: {
                                    src: 'https://storage.art-kangaroo.com' + item,
                                },
                                style: {
                                    width: '100px',
                                    marginRight: '10px'
                                },
                                on: {
                                    click: () => {
                                        this.lookContent(data, index)
                                    }
                                }
                            }, ))
                        })
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('span', [
                                h('div', data.title),
                                h('span', content),
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
    
                                h('Button', {
                                    props: Object.assign({}, this.removeProps, {
                                        icon: 'minus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(data)
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'plus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editorContent(data)
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'plus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.lookContent(data)
                                        }
                                    }
                                }, '查看'),
    
                            ])
                        ]);
                    }
                }
            },
            
             // 修改课程章节
            editorContent(data) {
                console.log(data);
                this.modelLabel='修改';
                this.editorData=data;
                this.appendData=data;

                if (data.level == 4) {
                    this.chapterLevel = true;
                } else {
                    this.chapterLevel = false;
                }

                this.chapterFrom.chapter_id = data.chapter_id;
                this.chapterFrom.parent_id = data.parent_id;
                this.chapterFrom.lesson_id = data.lesson_id;

                if (data.title) {
                    this.chapterFrom.name = data.title
                } else {
                    this.chapterFrom.name = ''
                }
                if (data.level == 4) {
                    if (data.type == 3 || data.type == 1) {
                        this.chapterFrom.images = data.images;
                    } else {
                        this.chapterFrom.images = [];
                    }
                    this.chapterFrom.type = data.type;
                    if (data.type == 2 || data.type == 3) {
                        this.chapterFrom.source_url = data.source_url;
                    } else {
                        this.chapterFrom.source_url = '';
                    }
                    
                } else {
                    this.chapterFrom.source_url = '';
                    this.chapterFrom.images = [];
                    this.chapterFrom.type = '';
    
                }
                this.classModel = true;
            },
            // 查看课次内容
            lookContent(data, index) {
                
                this.lessonContentModel = true;
                this.lessonContentType = data.type;
                if (index + 1) {
                    this.carouselVal = index;
                    if (data.type == 1 || data.type == 3) {
                        this.imgContent = [];
                        data.images.forEach((item) => {
                            this.imgContent.push('https://storage.art-kangaroo.com' + item)
                        })
                        if (data.type == 3) {
                            this.audioUrl = 'https://storage.art-kangaroo.com' + data.source_url;
    
                        }
                    } else if (data.type == 2) {
                        this.lessonContentVideo = 'https://storage.art-kangaroo.com' + data.source_url;
                    }
                } else {
                    this.carouselVal = 0;
                    if (data.type == 1 || data.type == 3) {
                        this.imgContent = [];
                        data.images.forEach((item) => {
                            this.imgContent.push('https://storage.art-kangaroo.com' + item);
                        })
                        if (data.type == 3) {
                            this.audioUrl = 'https://storage.art-kangaroo.com' + data.source_url;
    
                        }
                    } else if (data.type == 2) {
                        this.lessonContentVideo = 'https://storage.art-kangaroo.com' + data.source_url;
                    }
                }
            },
            // 保存章节
            okChapter(){
             
                if (!this.chapterLevel) {
                    if (this.chapterFrom.name == '') {
                        this.$Message.error('请填写章节名');
                        return;
                    }
                } else {
                    if (this.chapterFrom.type == '') {
                        this.$Message.error('请选择章节类型');
                        return;
                    } else {
                        if (this.chapterFrom.type == 1) {
                            if (this.chapterFrom.images.length == 0) {
                                this.$Message.error('请上传图片');
                                return;
    
                            }
                        } else if (this.chapterFrom.type == 2) {
                            if (this.chapterFrom.source_url == '') {
                                this.$Message.error('请上传视频');
                                return;
                            }
                        } else if (this.chapterFrom.type == 3) {
                            if (this.chapterFrom.images.length == 0) {
                                this.$Message.error('请上传图片');
                                return;
                            } else if (this.chapterFrom.source_url == '') {
                                this.$Message.error('请上传音频');
                                return;
                            }
                        } 
                    }
                }
                    modifySave({
                            chapter_id: this.chapterFrom.chapter_id,
                            name: this.chapterFrom.name,
                            type: this.chapterFrom.type,
                            images: this.chapterFrom.images,
                            source_url: this.chapterFrom.source_url,
                            member_type: 1

                    }).then(responese => {
                        responese=responese.data;
                            if (responese.code == 200) {
                                this.treeData[0].children.forEach((item, i) => {
                                        if (item.chapter_id == this.editorData.chapter_id) {
                                            item.title=responese.data[i].name;
                                            item.directory_type=responese.data[i].directory_type
                                        } else {
                                            item.children.forEach((list, j) => {
                                                if (list.chapter_id ==  this.editorData.chapter_id) {
                                                   list.title=responese.data[i].children[j].name;
                                                } else {
                                                    list.children.forEach((block, index) => {
                                                        if (block.chapter_id ==  this.editorData.chapter_id) {
                                                           block.title=responese.data[i].children[j].children[index].name;
                                                          
                                                        } else {
                                                            block.children.forEach((content, sub) => {
                                                                if(content.chapter_id ==  this.editorData.chapter_id){
                                                                    content.drawing_note=responese.data[i].children[j].children[index].children[sub].drawing_note;
                                                                    content.images=responese.data[i].children[j].children[index].children[sub].images;
                                                                    content.note_key=responese.data[i].children[j].children[index].children[sub].note_key;
                                                                    content.question=responese.data[i].children[j].children[index].children[sub].question;
                                                                    content.source_url=responese.data[i].children[j].children[index].children[sub].source_url;
                                                                    content.type=responese.data[i].children[j].children[index].children[sub].type;
                                                                    if(content.type==1){
                                                                        content.title="图片类："
                                                                    }else if(content.type==2){
                                                                        content.title="视频类："
                                                                    }else if(content.type==3){
                                                                        content.title="组图+音频类："
                                                                    }
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                this.classModel = false;
                                this.chapterFrom.lesson_id = this.lessonId;
                                this.lessonId = this.lessonId;
                            } else if (responese.code == 14004) {
                                this.$store.commit('logout', this);
                                this.$store.commit('clearOpenedSubmenu');
                                this.$router.push({
                                    name: 'login'
                                });
                                this.$Message.error(responese.msg);
                            } else {
                                console.log(responese)
                                this.$Message.error(responese.msg);
                            }
                        })
                
            },
            // 删除章节
            remove(data){
                this.chapter_id=data.chapter_id;
                this.lessonId=data.lesson_id;
                this.remindContent= '确认删除该章节吗？';//提醒内容
                this.remindModal=true; //提醒弹
            },
            //提醒弹出层的确定事件
            primaryRemind() {
                setDel({
                    chapter_id: this.chapter_id,
                    member_type:1,
                    lesson_id: this.lessonId,

                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        var chapter_id=this.chapter_id;
                        this.treeData[0].children.forEach((item, i) => {
                                        if (item.chapter_id == chapter_id) {
                                            this.treeData[0].children.splice(i, 1)
                                        } else {
                                            item.children.forEach((list, j) => {
                                                if (list.chapter_id == chapter_id) {
                                                    item.children.splice(j, 1)
                                                } else {
                                                    list.children.forEach((block, index) => {
                                                        if (block.chapter_id == chapter_id) {
                                                            list.children.splice(index, 1)
                                                          
                                                        } else {
                                                            block.children.forEach((content, sub) => {
                                                                if(content.chapter_id == chapter_id){
                                                                    block.children.splice(sub, 1)
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                        this.chapterFrom.lesson_id = this.lessonId;
                        this.lessonId = this.lessonId;
                        this.remindModal = false;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getChapterImgList(picList) {
                
                var arr = [];
                for (var i = 0; i < picList.length; i++) {
                    arr.push(picList[i].url.split('.com')[1])
                }
              
                this.chapterFrom.images = arr;
            },
            getVideos(list) {
                this.chapterFrom.source_url = list[0].url.split('.com')[1]
            },
            getAudioList(list){
                this.chapterFrom.source_url = list[0].url
            },
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            changEndtime(time) {
    
                if (time == '') {
                    this.formItem.end_time = '';
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel() {
                this.editClassModal = false;
    
            },
            // 课程内容弹层取消
            cancelLessonContent() {
                this.lessonContentModel = false;
            },
            // 取消保存章节
            cancelChapter() {
                this.classModel = false;
            },
            // 关闭提醒弹出
            cancelRemain() {
                this.remindModal = false;
            },
            //搜索框搜索
            handleSearch() {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage(row) {
                this.formItem.page = row;
                this.getData();
            },
    
        },
        created() {
            this.getData();
            this.getLessonTypeList();
        }
    };
</script>
